import usersReducer from './ducks/users';
import orchestratorReducer from './ducks/orchestrator';
import authReducer from './ducks/auth';
import analyticsReducer from './ducks/analytics';
import cartReducer from './ducks/cart';
import chatReducer from './ducks/chat';
import notificationReducer from './ducks/notifications';
import klarnaReducer from './ducks/klarna';
import collectJSReducer from './ducks/collectjs';
import funnelReducer from './ducks/funnel';
import digitalWalletsReducer from './ducks/digitalWallets';

// every slice the standalone funnel page's code can reach (funnelReducers.spec.js walks its imports);
// store.js registers these and adds the slices only the main app's pages read
export const funnelReducers = {
	authState: authReducer,
	analyticsState: analyticsReducer,
	users: usersReducer,
	orchestrator: orchestratorReducer,
	cartState: cartReducer,
	chatState: chatReducer,
	notificationState: notificationReducer,
	klarnaState: klarnaReducer,
	collectJSState: collectJSReducer,
	funnelState: funnelReducer,
	digitalWalletsState: digitalWalletsReducer
};
